var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    fill: "none",
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M36 0H0v23.996h36V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M36 0v2.5l-9.052 6.033-2.08 1.386-3.119 2.079 3.12 2.08L36 21.496v2.499h-3.75l-10.784-7.188-1.386-.925L18 14.497l-2.08 1.386-1.386.925-10.785 7.188H0v-2.5l9.052-6.033 2.08-1.386 3.119-2.079-3.12-2.08-2.079-1.385L0 2.499V0h3.75l10.784 7.188 1.386.925L18 9.499l2.08-1.386 1.386-.925L32.251 0H36Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    fillRule: "evenodd",
    d: "m23.618 9.919-3.12 2.079 3.12 2.08 2.08 1.385L36 22.331v1.665h-2.498l-12.036-8.023-1.386-.924L18 13.663l-2.08 1.386-1.386.924-12.036 8.023H0v-1.665l10.303-6.868 2.08-1.386 3.119-2.079-3.12-2.08-2.079-1.385L0 1.665V0h2.498l12.036 8.023 1.386.924L18 10.333l2.08-1.386 1.386-.924L33.502 0H36v1.665L25.697 8.533l-2.08 1.386Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M21.466 15.464v8.532h-6.932v-8.532H0V8.533h14.534V0h6.932v8.533H36v6.93H21.466Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    fillRule: "evenodd",
    d: "M20.08 14.077v9.919h-4.16v-9.919H0V9.92h15.92V0h4.16V9.92H36v4.158H20.08Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v23.996H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.bce8e9301b2170f1820eb268e3c1e420.svg";
export { ForwardRef as ReactComponent };